import React, { useState, useEffect } from "react";
import bgImage from "../../../Assets/Images/Home/who_we_are_bg.webp";
// import cricket from "../../../Assets/Images/Home/icons/cricket_white.webp";
// import basketball_white from "../../../Assets/Images/Home/icons/basketball_white.webp";
// import soccer_white from "../../../Assets/Images/Home/icons/soccer_white.webp";
// import football_white from "../../../Assets/Images/Home/icons/football_white.webp";
// import vollyball_white from "../../../Assets/Images/Home/icons/vollyball_white.webp";
import right_banner from "../../../Assets/Images/Home/who_we_are_frame.webp";
import AOS from "aos";
import "aos/dist/aos.css";

const WhoWeAreSection = () => {
  const [videoError, setVideoError] = useState(false);
  const [aboutData, setAboutData] = useState(null);
  const [loading, setLoading] = useState(true);

  // const sports = [
  //   { icon: cricket, color: "bg-blue-500", name: "Cricket" },
  //   { icon: football_white, color: "bg-red-500", name: "Football" },
  //   { icon: soccer_white, color: "bg-purple-600", name: "Soccer" },
  //   { icon: basketball_white, color: "bg-pink-600", name: "Basketball" },
  //   { icon: vollyball_white, color: "bg-yellow-500", name: "Volleyball" },
  // ];

  useEffect(() => {
    AOS.init({
      duration: 900,
      once: true,
      easing: "ease-in-out",
    });
  }, []);

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/whoarewe/getabout`
        );
        const data = await response.json();
        setAboutData(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching about data:", error);
        setLoading(false);
      }
    };

    fetchAboutData();
  }, []);

  if (loading) {
    return (
      <div
        style={{ backgroundImage: `url(${bgImage})` }}
        className="bg-gray-50 bg-cover bg-center bg-no-repeat px-4 md:px-8 lg:px-12 py-4 lg:py-8"
      >
        <div className="w-full mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 animate-pulse">
            <div className="space-y-4 py-6">
              <div className="h-5 bg-gray-300 rounded w-32"></div>
              <div className="space-y-3">
                <div className="h-8 bg-gray-300 rounded w-full"></div>
                <div className="h-8 bg-gray-300 rounded w-3/4"></div>
              </div>
              <div className="grid grid-cols-2 gap-3">
                {[...Array(6)].map((_, i) => (
                  <div key={i} className="h-4 bg-gray-300 rounded w-full"></div>
                ))}
              </div>
            </div>
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-video bg-gray-300"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{ backgroundImage: `url(${bgImage})` }}
      className="bg-gray-50 bg-cover bg-center bg-no-repeat px-4 md:px-8 lg:px-12 py-4 lg:py-8"
    >
      <div className="w-full mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16">
          {/* LEFT CONTENT */}
          <div
            className="space-y-2 md:space-y-4 lg:space-y-6 py-2 sm:py-4 md:py-6 lg:py-8"
            data-aos="fade-right"
          >
            <div
              className="text-primaryBtnHoverColor font-semibold text-sm md:text-base lg:text-lg tracking-wider"
              data-aos="fade-up"
            >
              {aboutData?.title || "Who are we ?"}
            </div>

            <h1
              className="text-3xl md:text-4xl lg:text-[2.6rem] font-heading font-bold text-primaryTextColor tracking-wide leading-relaxed lg:leading-[3rem]"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              {aboutData?.description ||
                "Strikes & Shots is a 48,000 sq ft indoor sports complex designed for athletes, families, and fans."}
            </h1>

            <div
              className="text-secondaryTextColor flex flex-col gap-y-4 text-base md:text-lg leading-relaxed max-w-2xl"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <p className="font-medium text-primaryTextColor">
                {aboutData?.subText ||
                  "Our climate-controlled facility features:"}
              </p>

              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-y-1.5 gap-x-6">
                {(aboutData?.features || []).map((feature, index) => (
                  <li
                    key={feature._id || index}
                    className="flex items-start gap-2"
                    data-aos="fade-right"
                    data-aos-delay={index * 100}
                  >
                    <span className="w-2.5 h-2.5 mt-2 bg-primaryBtnHoverColor rounded-full flex-shrink-0"></span>
                    <span>{feature.text}</span>
                  </li>
                ))}
              </ul>

              <p
                className="italic text-sm md:text-base text-gray-600"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                {aboutData?.conclusionText ? (
                  <>
                    {aboutData.conclusionText.split("compete")[0]}
                    <span className="font-semibold">compete</span>
                    {
                      aboutData.conclusionText
                        .split("compete")[1]
                        ?.split("train")[0]
                    }
                    <span className="font-semibold">train</span>
                    {
                      aboutData.conclusionText
                        .split("train")[1]
                        ?.split("celebrate")[0]
                    }
                    <span className="font-semibold">celebrate</span>
                    {
                      aboutData.conclusionText
                        .split("celebrate")[1]
                        ?.split("Strikes & Shots")[0]
                    }
                    <span className="text-primaryBtnHoverColor font-semibold">
                      Strikes & Shots
                    </span>
                    {aboutData.conclusionText.split("Strikes & Shots")[1] ||
                      "."}
                  </>
                ) : (
                  <>
                    Whether you're here to{" "}
                    <span className="font-semibold">compete</span>,{" "}
                    <span className="font-semibold">train</span>, or{" "}
                    <span className="font-semibold">celebrate</span> with
                    friends, you'll find it all at{" "}
                    <span className="text-primaryBtnHoverColor font-semibold">
                      Strikes & Shots
                    </span>
                    .
                  </>
                )}
              </p>
            </div>
          </div>

          {/* RIGHT CONTENT */}
          <div
            className="flex flex-col gap-y-4 sm:gap-y-6 justify-center"
            data-aos="fade-left"
          >
            <div
              className="relative rounded-2xl overflow-hidden shadow-2xl aspect-video"
              data-aos="zoom-in"
            >
              {!videoError ? (
                <video
                  src={aboutData?.videoUrl || right_banner}
                  autoPlay
                  muted
                  loop
                  playsInline
                  onError={() => setVideoError(true)}
                  className="w-full h-full object-cover"
                />
              ) : (
                <img
                  src={right_banner}
                  alt="Who we are"
                  className="w-full h-full object-cover"
                />
              )}
            </div>

            {/* <div
              className="w-full mx-auto"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div className="flex w-full flex-wrap sm:flex-nowrap px-4 lg:px-0 xl:px-4 justify-center md:justify-start gap-x-4 sm:gap-x-6 md:gap-x-8 lg:gap-x-4 items-center gap-2">
                {sports.map((sport, index) => (
                  <div
                    key={index}
                    className="group cursor-pointer flex flex-col items-center justify-center transform hover:scale-110 transition-all duration-300"
                    data-aos="zoom-in"
                    data-aos-delay={index * 100}
                  >
                    <div
                      className={`w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 lg:w-18 lg:h-18 ${sport.color} rounded-full flex items-center justify-center shadow-lg hover:shadow-xl group-hover:shadow-2xl transition-all duration-300`}
                    >
                      <span className="text-white">
                        <img
                          src={sport.icon}
                          alt={sport.name}
                          className="size-6 sm:size-8 md:size-9 lg:size-8 xl:size-10"
                        />
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhoWeAreSection;







// import React, { useState, useEffect } from "react";
// import bgImage from "../../../Assets/Images/Home/who_we_are_bg.webp";
// import cricket from "../../../Assets/Images/Home/icons/cricket_white.webp";
// import basketball_white from "../../../Assets/Images/Home/icons/basketball_white.webp";
// import soccer_white from "../../../Assets/Images/Home/icons/soccer_white.webp";
// import football_white from "../../../Assets/Images/Home/icons/football_white.webp";
// import vollyball_white from "../../../Assets/Images/Home/icons/vollyball_white.webp";
// import right_banner from "../../../Assets/Images/Home/who_we_are_frame.webp";

// const WhoWeAreSection = () => {
//   const [videoError, setVideoError] = useState(false);
//   const [aboutData, setAboutData] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const sports = [
//     { icon: cricket, color: "bg-blue-500", name: "Cricket" },
//     { icon: football_white, color: "bg-red-500", name: "Football" },
//     { icon: soccer_white, color: "bg-purple-600", name: "Soccer" },
//     { icon: basketball_white, color: "bg-pink-600", name: "Basketball" },
//     { icon: vollyball_white, color: "bg-yellow-500", name: "Volleyball" },
//   ];

//   useEffect(() => {
//     const fetchAboutData = async () => {
//       try {
//         const response = await fetch(
//           `${process.env.REACT_APP_API_URL}/whoarewe/getabout`
//         );
//         const data = await response.json();
//         setAboutData(data);
//         setLoading(false);
//       } catch (error) {
//         console.error("Error fetching about data:", error);
//         setLoading(false);
//       }
//     };

//     fetchAboutData();
//   }, []);

//   if (loading) {
//     return (
//       <div
//         style={{ backgroundImage: `url(${bgImage})` }}
//         className="bg-gray-50 bg-cover bg-center bg-no-repeat px-4 md:px-8 lg:px-12 py-4 lg:py-8"
//       >
//         <div className="w-full mx-auto">
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16">
//             <div className="space-y-2 md:space-y-4 lg:space-y-6 py-2 sm:py-4 md:py-6 lg:py-8 animate-pulse">
//               <div className="h-5 bg-gray-300 rounded w-32"></div>
//               <div className="space-y-3">
//                 <div className="h-8 bg-gray-300 rounded w-full"></div>
//                 <div className="h-8 bg-gray-300 rounded w-full"></div>
//                 <div className="h-8 bg-gray-300 rounded w-3/4"></div>
//               </div>
//               <div className="flex flex-col gap-y-4">
//                 <div className="h-6 bg-gray-300 rounded w-64"></div>
//                 <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-1.5 gap-x-6">
//                   {[1, 2, 3, 4, 5, 6, 7].map((item) => (
//                     <div key={item} className="flex items-start gap-2">
//                       <div className="w-2.5 h-2.5 mt-2 bg-gray-300 rounded-full flex-shrink-0"></div>
//                       <div className="h-4 bg-gray-300 rounded flex-1"></div>
//                     </div>
//                   ))}
//                 </div>
//                 <div className="space-y-2">
//                   <div className="h-4 bg-gray-300 rounded w-full"></div>
//                   <div className="h-4 bg-gray-300 rounded w-5/6"></div>
//                 </div>
//               </div>
//             </div>

//             <div className="flex flex-col gap-y-4 sm:gap-y-6 justify-center animate-pulse">
//               <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-video bg-gray-300"></div>

//               <div className="w-full mx-auto">
//                 <div className="flex w-full flex-wrap sm:flex-nowrap px-4 lg:px-0 xl:px-4 justify-center md:justify-start gap-x-4 sm:gap-x-6 md:gap-x-8 lg:gap-x-4 items-center gap-2">
//                   {[1, 2, 3, 4, 5].map((item) => (
//                     <div
//                       key={item}
//                       className="flex flex-col items-center justify-center"
//                     >
//                       <div className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 lg:w-18 lg:h-18 bg-gray-300 rounded-full"></div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div
//       style={{ backgroundImage: `url(${bgImage})` }}
//       className="bg-gray-50 bg-cover bg-center bg-no-repeat px-4 md:px-8 lg:px-12 py-4 lg:py-8"
//     >
//       <div className="w-full mx-auto">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16">
//           <div className="space-y-2 md:space-y-4 lg:space-y-6 py-2 sm:py-4 md:py-6 lg:py-8">
//             <div className="text-primaryBtnHoverColor font-semibold text-sm md:text-base lg:text-lg tracking-wider">
//               {aboutData?.title || "Who are we ?"}
//             </div>
//             <h1 className="text-3xl md:text-4xl lg:text-[2.6rem] font-heading font-bold text-primaryTextColor tracking-wide leading-relaxed lg:leading-[3rem]">
//               {aboutData?.description ||
//                 "Strikes & Shots is a 48,000 sq ft indoor sports complex designed for athletes, families, and fans."}
//             </h1>
//             <div className="text-secondaryTextColor flex flex-col gap-y-4 text-base md:text-lg leading-relaxed max-w-2xl">
//               <p className="font-medium text-primaryTextColor">
//                 {aboutData?.subText ||
//                   "Our climate-controlled facility features:"}
//               </p>

//               <ul className="grid grid-cols-1 sm:grid-cols-2 gap-y-1.5 gap-x-6">
//                 {(aboutData?.features || []).map((feature, index) => (
//                   <li
//                     key={feature._id || index}
//                     className="flex items-start gap-2"
//                   >
//                     <span className="w-2.5 h-2.5 mt-2 bg-primaryBtnHoverColor rounded-full flex-shrink-0"></span>
//                     <span>{feature.text}</span>
//                   </li>
//                 ))}
//               </ul>

//               <p className="italic text-sm md:text-base text-gray-600">
//                 {aboutData?.conclusionText ? (
//                   <>
//                     {aboutData.conclusionText.split("compete")[0]}
//                     <span className="font-semibold">compete</span>
//                     {
//                       aboutData.conclusionText
//                         .split("compete")[1]
//                         ?.split("train")[0]
//                     }
//                     <span className="font-semibold">train</span>
//                     {
//                       aboutData.conclusionText
//                         .split("train")[1]
//                         ?.split("celebrate")[0]
//                     }
//                     <span className="font-semibold">celebrate</span>
//                     {
//                       aboutData.conclusionText
//                         .split("celebrate")[1]
//                         ?.split("Strikes & Shots")[0]
//                     }
//                     <span className="text-primaryBtnHoverColor font-semibold">
//                       Strikes & Shots
//                     </span>
//                     {aboutData.conclusionText.split("Strikes & Shots")[1] ||
//                       "."}
//                   </>
//                 ) : (
//                   <>
//                     Whether you're here to{" "}
//                     <span className="font-semibold">compete</span>,{" "}
//                     <span className="font-semibold">train</span>, or{" "}
//                     <span className="font-semibold">celebrate</span> with
//                     friends, you'll find it all at{" "}
//                     <span className="text-primaryBtnHoverColor font-semibold">
//                       Strikes & Shots
//                     </span>
//                     .
//                   </>
//                 )}
//               </p>
//             </div>
//           </div>

//           <div className="flex flex-col gap-y-4 sm:gap-y-6 justify-center">
//             <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-video">
//               {!videoError ? (
//                 <video
//                   src={aboutData?.videoUrl || right_banner}
//                   autoPlay
//                   muted
//                   loop
//                   playsInline
//                   onError={() => setVideoError(true)}
//                   className="w-full h-full object-cover"
//                 />
//               ) : (
//                 <img
//                   src={right_banner}
//                   alt="Who we are"
//                   className="w-full h-full object-cover"
//                 />
//               )}
//             </div>

//             <div className="w-full mx-auto">
//               <div className="flex w-full flex-wrap sm:flex-nowrap px-4 lg:px-0 xl:px-4 justify-center md:justify-start gap-x-4 sm:gap-x-6 md:gap-x-8 lg:gap-x-4 items-center gap-2">
//                 {sports.map((sport, index) => (
//                   <div
//                     key={index}
//                     className="group cursor-pointer flex flex-col items-center justify-center transform hover:scale-110 transition-all duration-300"
//                   >
//                     <div
//                       className={`w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 lg:w-18 lg:h-18 ${sport.color} rounded-full flex items-center justify-center shadow-lg hover:shadow-xl group-hover:shadow-2xl transition-all duration-300`}
//                     >
//                       <span className="text-white">
//                         <img
//                           src={sport.icon}
//                           alt={sport.name}
//                           className="size-6 sm:size-8 md:size-9 lg:size-8 xl:size-10"
//                         />
//                       </span>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default WhoWeAreSection;
